// extracted by mini-css-extract-plugin
export default {"subtitle":"CardContentComponent_subtitle__h6JmM","map":"CardContentComponent_map__QaMO5"};